import { tr } from "@/i18n";

/**
 * Opens one of Atlas's panels (atlasintelligence.tech) in a new tab, already
 * signed in as the person using Connect.
 *
 * The API signs a 60-second ticket for this person and panel (POST
 * sso/atlas/<target>, which needs atlas.sms or atlas.ai); Atlas checks it and
 * opens that person's own Atlas session, matched by e-mail.
 *
 * The tab is opened during the click itself: browsers block a tab opened after
 * waiting for an answer. The ticket is then posted from inside that tab, so it
 * never sits in an address, a history entry or a server log, and the tab is cut
 * loose from this one first (no opener, no referrer).
 *
 * Resolves to "" when Atlas is opening, or to what went wrong, in words.
 */
export async function openAtlas(target) {
  const tab = window.open("", "_blank");
  if (!tab) return tr("The browser blocked the new tab. Allow pop-ups for Connect and try again.");
  tab.opener = null;
  const doc = tab.document;
  doc.title = "Atlas";
  doc.body.textContent = tr("Opening Atlas…");

  try {
    const { data } = await window.$http.axios.post("sso/atlas/" + target);
    if (!data || !data.status) throw new Error((data && data.message) || tr("Atlas could not be opened."));

    const referrer = doc.createElement("meta");
    referrer.name = "referrer";
    referrer.content = "no-referrer";
    doc.head.appendChild(referrer);

    const form = doc.createElement("form");
    form.method = "POST";
    form.action = data.url;
    const field = doc.createElement("input");
    field.type = "hidden";
    field.name = "ticket";
    field.value = data.ticket;
    form.appendChild(field);
    doc.body.appendChild(form);
    form.submit();
    return "";
  } catch (e) {
    tab.close();
    const answer = e && e.response && e.response.data;
    return (answer && answer.message) || (e && e.message) || tr("Atlas could not be opened.");
  }
}
